// extracted by mini-css-extract-plugin
export default {"noscroll":"ModalProvider_noscroll__t8qXB","root":"ModalProvider_root__fq5mR"};